<template>
  <div class="home" >
      <router-view class="innerPage"/>
      <van-tabbar class="homeBar" v-model="active" style="z-index: 9999;">
        <van-tabbar-item name="home" icon="wap-home" @click="go('view1','home')">首页</van-tabbar-item>
        <van-tabbar-item name="setting" icon="manager" @click="go('view2','setting')">个人中心</van-tabbar-item>
      </van-tabbar>
  </div>
</template>
<script>
import _URL from "../../lib/url";
import { Toast,Dialog } from 'vant';
import { getAction, postAction } from "@/api/manage";
export default {
  name: "sign",
  components: {},
  data:function() {
    return {
      active:localStorage.getItem('act')?localStorage.getItem('act'):'home'
    };
  },
  mounted:function() {
  },
  methods: {
   go(val,act){
     localStorage.setItem('act',act);
     let that = this;
     that.$router.push({path:val});
   },
  }
};
</script>
<style lang="less">
.home{
  .homeBar .van-icon{
    font-size: 23px !important;
  }
  .innerPage{
    margin-bottom: 50px;
    background: #f9f9f9;
  }
}
</style>

